import graphqlClient from '@/graphql/graphql-client';
import { eqFromWhere, toListQueryVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';
import {
  ApiUsageLogssDocument,
  type ApiUsageLogssQuery,
  type ApiUsageLogssQueryVariables,
} from '@/graphql/generated/graphql';

export type ApiUsageLogItem = NonNullable<
  NonNullable<ApiUsageLogssQuery['getApiUsageLogss']>['items']
>[number];
export type GetApiUsageLogsResponse = ApiUsageLogssQuery;

export const toApiUsageLogsVariables = (
  params?: ListQueryVariables<Record<string, unknown>> | null
): ApiUsageLogssQueryVariables => {
  const { where, paging } = toListQueryVariables(params);
  return {
    organizationId: eqFromWhere(where, 'OrganizationId'),
    pageNo: paging.pageNo,
    pageSize: paging.pageSize,
  };
};

export const useGetApiUsageLogs = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toApiUsageLogsVariables(params);
  return useQuery({
    queryKey: ['api-usage-logs', variables],
    queryFn: () => graphqlClient.request(ApiUsageLogssDocument, variables),
  });
};

export const requestApiUsageLogs = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toApiUsageLogsVariables(params);
  return graphqlClient.request(ApiUsageLogssDocument, variables);
};

export const GET_API_USAGE_LOGS_QUERY = ApiUsageLogssDocument;
